import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { MultipleFileUploadField } from "../components/FileUpload/MultipleFileUploadField";
import Textarea from "../components/Form/Textarea";
import InputText from "../components/Form/InputText";
import RadioGroup from "../components/Form/RadioGroup";
import Stepper from "../components/Stepper/Stepper";
import DatePicker from "../components/Form/Datepicker";

export const radiotest_TICKET = "ticket";
export const radiotest_TAXI = "taxi";
export const radiotest_CAR = "car";

export default function Kitchensink() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });
                    navigate("/summary");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    inputtest: Yup.string().required(
                        "Vänligen fyll text"
                    ),
                    radiotest: Yup.string().test(
                        "at-least-one-radio-selected",
                        "Vänligen välj ett svarsalternativ för att gå vidare till nästa steg",
                        (value) => {
                            return value === radiotest_TICKET ||
                                value === radiotest_TAXI ||
                                value === radiotest_CAR;
                        }
                    ),

                    textareatest: Yup.string().required(
                        "Vänligen fyll i textarea"
                    ),
                    filesuploadtest: Yup.array()
                        .of(Yup.mixed().required("Kvitto är obligatoriskt"))
                        .min(1, "Vänligen bifoga ett kvitto innan du går vidare."),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <Form noValidate>
                            <Box>
                                <h2 className="mb-8" ref={h2Ref} tabIndex={-1} id="radiotest">Lorem, ipsum dolor sit amet consectetur adipisicing elit</h2>

                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Error excepturi eveniet esse molestias ipsa? Nobis quaerat ipsam ducimus voluptatum sunt, deserunt veritatis incidunt facere sequi, optio molestiae rem rerum id?</p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="inputtest"
                                    label={
                                        <>
                                            Mejladress för kontakt <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                    autocomplete={"email"}
                                />

                                <RadioGroup name="radiotest" options={[
                                    { id: "ticket", value: "ticket", label: "Jag vill ha ersättning av priset för en enkelbiljett" },
                                    { id: "taxi", value: "taxi", label: "Jag vill ha ersättning för resa med taxi" },
                                    { id: "car", value: "car", label: "Jag vill ha ersättning för resa med bil" },
                                ]} />

                                <Textarea
                                    name="textareatest"
                                    maxLength={5000}
                                    currentText={values.textareatest}
                                    label={
                                        <>
                                            Information om resan <span>(Frivilligt)</span>
                                        </>
                                    }
                                />

                                <DatePicker value="" name="testpicker" label={<>Testpicker <span>(Obligatoriskt)</span></>} />

                                <MultipleFileUploadField
                                    currentFiles={values.filesuploadtest}
                                    multiple={true}
                                    type="Kvitton"
                                    label="Bifoga kvitto från taxiresa"
                                    inputId="taxireceipt"
                                    inputName="filesuploadtest"
                                />


                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
